import type { ComponentType} from 'react';
import { useEffect, useState } from 'react';

import classNames from 'classnames';

interface SwitchingIconProps {
  disabled?: boolean;
  icons: ComponentType<{ className?: string }>[];
  className?: string;
  iconContainerClassName?: string;
}

const SwitchingIcon = ({
  disabled,
  icons,
  className,
  iconContainerClassName,
}: SwitchingIconProps) => {
  const [activeIconIndex, setActiveIconIndex] = useState(0);

  const totalIcons = icons.length;

  useEffect(() => {
    if (disabled) {
      return;
    }

    const intervalId = setInterval(() => {
      setActiveIconIndex((oldState) => {
        const nextState = oldState + 1;

        return nextState >= totalIcons ? 0 : nextState;
      });
    }, 3000);

    return () => {
      clearInterval(intervalId);
    };
  }, [totalIcons, disabled]);

  return (
    <div className={classNames('relative size-6', className)}>
      {icons.map((Icon, i) => {
        const isActive = i === activeIconIndex;

        return (
          <div
            key={i}
            className={classNames(
              iconContainerClassName,
              'absolute size-full transition-all duration-[600ms] ease-out',
              {
                'z-[1] opacity-1 scale-100': isActive,
                'opacity-0 scale-75': !isActive,
              },
            )}
          >
            <Icon className="size-full" />
          </div>
        );
      })}
    </div>
  );
};

export default SwitchingIcon;
